export default "__VITE_ASSET__b616b1af__"